// extracted by mini-css-extract-plugin
export default {"codeEditor":"CodeEditor_codeEditor__HLxik","monacoEditor":"CodeEditor_monacoEditor__86RfF"};